import { LAYER_DEFS, SELECTED_STYLE, GEWAS_COLORS, GEWAS_DEFAULT_COLOR } from '../config/layers.js';

export function addCoreLayers(map) {
  // Natura 2000 fill
  map.addLayer({
    id: 'natura2000-fill',
    type: 'fill',
    source: 'natura2000',
    paint: {
      'fill-color': '#2ecc71',
      'fill-opacity': 0.2,
    },
  });

  // Natura 2000 stroke
  map.addLayer({
    id: 'natura2000-stroke',
    type: 'line',
    source: 'natura2000',
    paint: {
      'line-color': '#27ae60',
      'line-width': 2,
      'line-dasharray': [4, 3],
    },
  });

  // Buffer zones fill (pre-computed, starts hidden)
  map.addLayer({
    id: 'buffer-zones-fill',
    type: 'fill',
    source: 'buffer-zones',
    layout: { visibility: 'none' },
    paint: {
      'fill-color': '#3498db',
      'fill-opacity': 0.05,
    },
  });

  // Buffer zones stroke
  map.addLayer({
    id: 'buffer-zones-stroke',
    type: 'line',
    source: 'buffer-zones',
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#2980b9',
      'line-width': 1.5,
    },
  });

  // Parcels fill
  map.addLayer({
    id: 'parcels-fill',
    type: 'fill',
    source: 'parcels',
    paint: {
      'fill-color': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        '#00e5ff',
        ['match', ['get', 'gewas'],
          ...GEWAS_COLORS.flatMap(({ gewas, color }) => [gewas, color]),
          GEWAS_DEFAULT_COLOR,
        ],
      ],
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        0.4,
        0.3,
      ],
    },
  });

  // Parcels stroke
  map.addLayer({
    id: 'parcels-stroke',
    type: 'line',
    source: 'parcels',
    paint: {
      'line-color': '#1e8449',
      'line-width': 0.75,
      'line-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        0,
        0.5,
      ],
    },
  });

  // Own parcels fill (subtle magenta tint)
  map.addLayer({
    id: 'own-parcels-fill',
    type: 'fill',
    source: 'parcels',
    filter: ['==', ['get', '_isOwn'], true],
    paint: {
      'fill-color': '#e91e63',
      'fill-opacity': 0.08,
    },
  });

  // Own parcels stroke (magenta outline)
  map.addLayer({
    id: 'own-parcels-stroke',
    type: 'line',
    source: 'parcels',
    filter: ['==', ['get', '_isOwn'], true],
    paint: {
      'line-color': '#e91e63',
      'line-width': 2.5,
    },
  });

  // Selected parcel highlight
  map.addLayer({
    id: 'selected-parcel',
    type: 'line',
    source: 'parcels',
    paint: {
      'line-color': SELECTED_STYLE.color,
      'line-width': SELECTED_STYLE.strokeWidth,
    },
    filter: ['==', ['get', 'id'], ''],
  });

  // Selected parcel fill
  map.addLayer({
    id: 'selected-parcel-fill',
    type: 'fill',
    source: 'parcels',
    paint: {
      'fill-color': SELECTED_STYLE.color,
      'fill-opacity': SELECTED_STYLE.fillOpacity,
    },
    filter: ['==', ['get', 'id'], ''],
  });
}

export function addWaterLayers(map) {
  // Insert water layers below parcels
  const beforeLayer = 'parcels-fill';

  // Water fill
  map.addLayer({
    id: 'water-fill',
    type: 'fill',
    source: 'water',
    paint: {
      'fill-color': '#2980b9',
      'fill-opacity': 0.5,
    },
  }, beforeLayer);

  // Water stroke
  map.addLayer({
    id: 'water-stroke',
    type: 'line',
    source: 'water',
    paint: {
      'line-color': '#1a5276',
      'line-width': 1,
    },
  }, beforeLayer);

  // Sync visibility with checkbox state (layers load after user may have toggled)
  const waterCb = document.getElementById('toggle-water');
  if (waterCb && !waterCb.checked) {
    toggleLayerVisibility(map, 'water', false);
  }
}

export function getLayerIds(layerId) {
  return [`${layerId}-fill`, `${layerId}-stroke`];
}

export function toggleLayerVisibility(map, layerId, visible) {
  const ids = getLayerIds(layerId);
  const visibility = visible ? 'visible' : 'none';
  for (const id of ids) {
    if (map.getLayer(id)) {
      map.setLayoutProperty(id, 'visibility', visibility);
    }
  }
}
